import {
  Injectable
} from '@angular/core';
import {
  BehaviorSubject
} from 'rxjs';
import {
  ThingsModel
} from 'src/app/models/ThingsModel';
import {
  UserModel
} from 'src/app/models/UserModel';
import {
  ApiService
} from '../api/api.service';

@Injectable({
  providedIn: 'root'
})
export class GlobalsService {


  public resetToken = "";
  public currentview: "login" | "app" | "loading" = "loading";
  public users: UserModel[];
  public things: any[];
  public selectedSidenav: "Dashboard" | "Users" | "Things" | "Groups" = "Dashboard";

  public showActivation: boolean = false;
  public activationResult: boolean = false;
  public isHandSet: boolean = false;
  public isSmall: boolean = false;

  public activeUser: any = {
    name: "Guest user"
  }
  //Helium Rewards
  public rewards = {
    total: {
      day: 0,
      week: 0,
      month: 0,
      total: 0
    }
  }
  public rewardsDayLoaded = false;
  public rewardsWeekLoaded = false;
  public rewardsMonthLoaded = false;
  public rewardsTotalLoaded = false;
  public rewardsStatsLoaded = false;

  public devicesLoading = false;
  public directRouting = false;
  public selectedRoute: "dashboard" | "devicelist" | "devicedetails" | "account" = "dashboard";

  //Helium stats
  public synced = 0;
  public relayed = 0;
  public online = 0;
  public offline = 0;
  public statsloaded = false;
  public isReset: boolean = false;
  public showGatekeeper: boolean = true;



  //Helium Device list
  public devices = [
    "11GXHN1dqQG2rui5Do6eVtarDm5PGUijqmnLT7nd8kkfkXWTEFn",
    "11YijBnA1upnmEeQTSdo64XGWDhAKXcxBmdwTYghzLADbbxFj3B",
    // "112dJtn3FibfFgUt2vH75qB5pJ1EHpLbSdM2e26e9nwM6zEyxnVC",
    // "11jwknEMTrMhPqJen61RR33UVaiNy5qQbSDFpCsdG2K7Qx7XnLV",
    // "1122hxCsrLofbTvYRuQeMNz2xMBnH7eqPEGRUPjQTne7sMbJfBAc",
    // "11uYy3uq3bsdYtbGr6dugq4MUnZ3hz9VHRxRZ9kGY9gHLWorjFb",
    // "112wWEWM23Q8Eu8ZxWZos4RHr6eTPUU1J9bxMAysbkxMUChRbF8",
    // "11ZV2fMuSYeKLWtEhChmdFfCH1QvNq3Pwp499kSMoRbt46LUXge",
    // "112LNmJ7MX6JE7BRZPkx9oEbS1CUrV6oFnZcdEcs3rsHFzJbemds",
    // "11NKaicYpBy4EhXXreiVD3UFNMQFgXHHD58vhM6mKFhux1831jE"
  ];

  //List of all devices // Full
  public fullDeviceList = [];



  //helium devices
  // public deviceList = [];
  public snackbarConfig = {
    duration: 3000
  };

  constructor() {}

  public convertDateString(date: Date): string {
    var DD = String(date.getDate()).padStart(2, '0');
    var MM = String(date.getMonth() + 1).padStart(2, '0'); //January is 0!
    var YYYY = date.getFullYear();

    let HH = `${date.getHours()}`.padStart(2, '0');
    let mm = `${date.getMinutes()}`.padStart(2, '0');
    let ss = `${date.getSeconds()}`.padStart(2, '0');

    let retDate = `${HH}:${mm}:${ss}  ${DD}/${MM}/${YYYY} `;

    return retDate;
  }

  public arrayFindWithAttr(array, attr, value) {
    for (var i = 0; i < array.length; i += 1) {
      if (array[i][attr] === value) {
        return i;
      }
    }
    return -1;
  }


  public secondsToDhms(seconds) {
    seconds = Number(seconds);
    var d = Math.floor(seconds / (3600 * 24));
    var h = Math.floor(seconds % (3600 * 24) / 3600);
    var m = Math.floor(seconds % 3600 / 60);
    var s = Math.floor(seconds % 60);

    var dDisplay = d > 0 ? d + (d == 1 ? " day, " : " days, ") : "";
    var hDisplay = h > 0 ? h + (h == 1 ? " hour, " : " hours, ") : "";
    var mDisplay = m > 0 ? m + (m == 1 ? " minute, " : " minutes, ") : "";
    var sDisplay = s > 0 ? s + (s == 1 ? " second" : " seconds") : "";
    return dDisplay + hDisplay + mDisplay + sDisplay;
  }

  public getLocalDateString(date: Date) {
    return `${date.toLocaleString()} (GMT${date.getTimezoneOffset()>0?"-":"+"}${Math.abs(date.getTimezoneOffset()/60)})`
  }

  public timeSince(timeStamp:any) {
    var now = new Date();
      let secondsPast = (now.getTime()/1000 - timeStamp);
    if (secondsPast < 60) {
      return Math.floor(secondsPast) + 's';
    }
    if (secondsPast < 3600) {
      return Math.floor(secondsPast / 60) + 'm';
    }
    if (secondsPast <= 86400) {
      return Math.floor(secondsPast / 3600) + 'h';
    }
    if (secondsPast > 86400) {
      let dt = new Date(timeStamp*1000)

      let day = dt.getDate();
      let month = dt.toDateString().match(/ [a-zA-Z]*/)[0].replace(" ", "");
      let year = dt.getFullYear() == now.getFullYear() ? "" : " " + dt.getFullYear();
      return day + " " + month + year;
    }
  }

}
